import React from "react";
import { useTranslation } from "react-i18next";

import add1Img from "../../assets/images/extras/additional-driver.png";

function AditionalDriverPopup({
  isOpen,
  handleNoClick,
  handleYesClick,
  additionalDriverPresent,
}) {
  const { t } = useTranslation();

  return isOpen ? (
    <div className="modal show-modal extra-driver">
      <div className="content">
        <div className="row justify-content-end"></div>
        <div className="row">
          <div className="col-4">
            <img
              style={{ height: "82px" }}
              src={add1Img}
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="col-8">
            {additionalDriverPresent ? (
              <h2>{t("additionalDriverFillDetailsQuestion")}</h2>
            ) : (
              <h2>{t("additionalDriverQuestion")}</h2>
            )}
            <button onClick={handleYesClick} id="yes" className="btn mr-3">
              {t("yes")}
            </button>
            <button onClick={handleNoClick} id="no" className="btn">
              {t("no")}
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {additionalDriverPresent ? null : (
              <small>{t("additionalDriverAlertMessage")}</small>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default AditionalDriverPopup;
